module.exports = __webpack_public_path__ + "img/BLUESKYVILLA.b4966f96.png";